import axios from '../../helpers/axios-setup';
import { User } from '../../redux/modules/user/types';

export const getUserProfile = () => axios.get<User>('/account');
